import React from "react";

const CheckIconGreen = React.forwardRef(
    function CheckIconGreen(
        {
            title,
            titleId,
            ...props
        },
        svgRef
    ) {
        return (
            <svg
                viewBox="0 0 20 20"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                ref={svgRef}
                aria-labelledby={titleId}
                fill="none"
                stroke="none"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="feather feather-eye-off"
                {...props}
            >
                {title ? <title id={titleId}>{title}</title> : null}
                <path d="M0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10Z" fill="#DCFAE6"/>
                <path fillRule="evenodd" clipRule="evenodd" d="M14.2468 6.15835L8.28017 11.9167L6.69684 10.225C6.40518 9.95002 5.94684 9.93335 5.61351 10.1667C5.28851 10.4084 5.19684 10.8334 5.39684 11.175L7.27184 14.225C7.45518 14.5084 7.77184 14.6834 8.13017 14.6834C8.47184 14.6834 8.79684 14.5084 8.98018 14.225C9.28018 13.8334 15.0052 7.00835 15.0052 7.00835C15.7552 6.24169 14.8468 5.56669 14.2468 6.15002V6.15835Z" fill="#079455"/>

            </svg>
        );
    }
);

export default CheckIconGreen;
